import {FC, useEffect} from 'react';
import { useSelector } from 'react-redux';

import { dispatch } from 'store';
import { RootState } from 'types';
import {setRegisterData, nextRegisterStep, setCurrentStripePrice, getStripePrices} from 'modules/auth/actions';

import { Input, Select, Button } from 'views/components';
import { t } from 'utils';

import styles from './FirstStep.module.css';

import texts from '../../../texts';

export const FirstStepClinic: FC = () => {
  const { registerData, stripePrices } = useSelector((state: RootState) => state.auth);
  const stripePricesMonthly: any = [];

  useEffect(() => {
    dispatch(getStripePrices.request());
  }, []);

  const handleInputChange = (event: any) => {
    const { name, value } = event.target;
    dispatch(setRegisterData(name, value));
  };

  stripePrices.map(el => {
    if (el.billing_type === 'annually') {
      stripePricesMonthly.push(el);
    } else if (el.billing_type === 'ppc') {
      stripePricesMonthly.push(el);
    }
  });



  const handleSelectChange = (event: any) => {
    const { value } = event.target;
    const item = stripePrices.find(el => el.nickname.includes(value)) || null;
    dispatch(setCurrentStripePrice(item));
  };

  const countOfCamers = ['1', '2', '3', '4', '5'];

  const disabled =
    !registerData.clinicName || !registerData.yourPosition || !registerData.howManyCameras;
  return (
    <div className={styles.container}>
      <p>
        {t(texts.general.step)} 1 {t(texts.general.of)} 3
      </p>
      <h1 style={{ fontSize: 40, fontWeight: 'bold', lineHeight: '50px' }}>
        {t(texts.clinicFirstStepTitle)}
      </h1>
      <p style={{ fontSize: '14px' }}>{t(texts.clinicFirstStepDesc)} </p>
      <Input
        name="clinicName"
        value={registerData.clinicName}
        onChange={(e: any) => handleInputChange(e)}
        label={t(texts.clinicFirstStepInputLabel1)}
        maxLength={64}
      />
      <Input
        name="yourPosition"
        value={registerData.yourPosition}
        onChange={(e: any) => handleInputChange(e)}
        label={t(texts.clinicFirstStepInputLabel2)}
        maxLength={64}
      />
      <div style={{ width: '253px' }}>
        <Select
          name="howManyCameras"
          onChange={(e: any) => handleSelectChange(e)}
          data={countOfCamers}
          label={t(texts.clinicFirstStepInputLabel3)}
        />
      </div>
      <div style={{ marginTop: '40px', marginBottom: '50px', width: '150px' }}>
        <Button
          disabled={disabled}
          title={t(texts.general.continue)}
          onClick={() => dispatch(nextRegisterStep())}
        />
      </div>
    </div>
  );
};
